import { useEDCFlow } from "@smvtech/x-flux";
import { Flag } from "x-wings";
import { Flags } from "x-wings/Components/Flag/types";

type Props = {
	travellerName?: string;
};

const AlreadySubmittedScreen = ({ travellerName }: Props) => {
	const { order } = useEDCFlow();

	return (
		<div className="h-dvh bg-white flex flex-col overflow-hidden">
			<div className="bg-white z-20 border-b border-gray-100 shrink-0">
				<div className="flex items-center justify-between px-4 py-[13px]">
					<div className="w-5" />
					<div className="flex items-center gap-2">
						<Flag code={order?.country.symbol as Flags} size="m" hasBorder hasBorderRadius hasDropShadow />
						<span className="text-sm font-medium text-black">
							{travellerName ? `${travellerName}'s` : "Your"} Information
						</span>
					</div>
					<div className="w-5" />
				</div>
			</div>

			<div className="flex-1 overflow-y-auto bg-white flex flex-col items-center px-6 py-10">
				<img
					src="https://stampmyvisa-public.s3.ap-south-1.amazonaws.com/biz-share-questionnaire/airplane-success.png"
					alt="Already submitted"
					className="w-[220px] h-[220px] mb-8"
				/>

				<h1 className="text-2xl font-bold text-center text-gray-900 mb-2">Already Submitted!</h1>

				<p className="text-sm text-gray-500 text-center max-w-xs mb-8">
					You have already submitted your application for{" "}
					<span className="text-indigo-600 font-bold">{order?.country?.name}</span>.
				</p>
			</div>
		</div>
	);
};

export default AlreadySubmittedScreen;

